const takoColors = {
    /* Light Neutral */
    N0: '#ffffff', // White
    N5: '#fcfcfc', // Snow
    N10: '#fafafa', // Virgil Abloh
    N15: '#f2f2f4', // Fog
    N20: '#e9e9ec', // Athens gray
    N30: '#e0dee3', // Mischka
    N40: '#d1ced4', // Cloud vision

    /* Mid Neutral */
    N50: '#bbb7c1', // Silverware
    N100: '#a3a0ac', // Santas gray
    N200: '#938d9c', // Gentle mauve
    N300: '#7d7788', // Dull mauve
    N400: '#696176', // Purple punch

    /* Dark Neutral */
    N500: '#594e69', // Mulled wine
    N600: '#483760', // Martinique
    N700: '#342349', // Russian violet
    N800: '#291544', // Valhalla
    N900: '#1e0d35', // Kraken ink

    /* Green */
    G25: '#f1fbf5', // Narvik
    G50: '#e4f8ec', // Honeydew
    G75: '#cff3de', // Granny apple
    G100: '#a0e8bd', // Magic mint
    G200: '#6ada97', // Pastel green
    G300: '#34cd71', // Jungle
    G400: '#2bb061', // Eucalyptus
    G500: '#1e7b44', // Pine
    G550: '#196739', // Forest
    G600: '#14522E', // Leaf

    /* Orange */
    O25: '#fff9ee', // Dawn
    O50: '#fff4dd', // Champagne
    O75: '#ffebc3', // Egg white
    O100: '#ffd888', // Grandis
    O200: '#ffc144', // Honey
    O250: '#ffab00', // Gold
    O300: '#e59a00', // Pumpkin
    O400: '#cc8900', // Orange choco
    O500: '#996700', // Caramel choco
    O550: '#805600', // Soil
    O600: '#664400', // Brown

    /* Red */
    R25: '#fff2f3', // Chablis
    R50: '#ffe7e9', // Misty rose
    R75: '#ffd5d9', // Cosmos
    R100: '#ffacb3', // Blossom
    R200: '#ff6673', // Bittersweet
    R300: '#ff3849', // Electric crimson
    R400: '#de0013', // Vermilion
    R500: '#cc0011', // Monza
    R600: '#b2000f', // Firebrick

    /* Primary Purple */
    P25: '#f5effd', // Selago
    P50: '#ece1fb', // Pale purple
    P75: '#e2d1f9', // Moonraker
    P100: '#be96f3', // Wisteria
    P200: '#9859ea', // Musa
    P300: '#721ce3', // Kraken purple
    P350: '#6018bf', // Purple heart
    P400: '#4c1397', // Blue gem

    /* Fuchsia */
    F50: '#fce8fd', // Cotton candy
    F100: '#f9c4fb', // Perfume
    F200: '#f28af6', // Orchid
    F300: '#ec4ff2', // Kraken skin
    F400: '#c00fc7', // Steel pink
    F500: '#9a0c9f', // Dark magenta
    F600: '#730978', // Royal purple
    F700: '#4d0650', // Bossanova

    /* Blue */
    B50: '#e5f6fe', // Foam
    B100: '#bfeafc', // Dreamy
    B200: '#7ed4f9', // Sky
    B300: '#3ebff6', // Malibu
    B400: '#098cc4', // Sardinia
} as const;

export default takoColors;
export type TakoColorsUnitKey = keyof typeof takoColors;
export type TakoColorsUnitValue = (typeof takoColors)[keyof typeof takoColors];
